import {
  ReportTable,
  ReportTableData,
  ReportTableHeader,
} from '../../../components/Table/types';
import {useLeadSourceSumReportQuery, usePhaseLeadSourceReportsQuery} from 'api';
import React from 'react';
import useLeadSourceHeaders from './useLeadSourceHeaders';

const sumValues = (values: number[]): number => {
  const total = values
    .filter(Boolean)
    .reduce((accumulator, currentValue) => accumulator + currentValue, null);
  return total;
};

const useTableData = (): ReportTable => {
  const headers: ReportTableHeader[] = useLeadSourceHeaders();
  const {data: {phaseLeadSourceReports = []} = {}} =
    usePhaseLeadSourceReportsQuery({});
  const {data: {leadSourceSumReport = null} = {}} = useLeadSourceSumReportQuery(
    {},
  );
  const sumReportData = React.useMemo(() => {
    if (!leadSourceSumReport) {
      return;
    }
    return {
      label: leadSourceSumReport.name,
      values: [
        sumValues(leadSourceSumReport.values),
        ...leadSourceSumReport.values,
      ],
      callProps: {
        style: {
          borderBottom: 'double 3px var(--text-color-2)',
        },
      },
    };
  }, [leadSourceSumReport]);

  const reportData = React.useMemo(() => {
    return phaseLeadSourceReports.map((report) => {
      return {
        label: report.name,
        values: [sumValues(report.values), ...report.values],
      };
    });
  }, [phaseLeadSourceReports]);

  const data: ReportTableData[] = [sumReportData, ...reportData].filter(
    Boolean,
  );

  return {
    data,
    headers,
  };
};

export default useTableData;
